import React, { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

// Atomic
import { ResponsiveSize } from '@/components/atomic/_enums'
import Text from '@/components/atomic/atoms/Text'
import Card from '@/components/atomic/molecules/Card'
import Icon from '@/components/cell/atoms/Icon'
// Cell
import { IconPack } from '@/components/cell/atoms/Icon/enum'
import COLOR from '@/components/cell/designTokens/color'

const ModalCointainer = styled.div`
  margin-top: 60px;
  height: 100%;
  max-height: calc(100% - 60px - 130px);

  div[class^='Card'] {
    height: 100%;
  }

  .modalHeader {
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
    height: 56px;
    border-bottom: 1px solid ${COLOR.gray400};
    h4 {
      width: 100%;
    }
    button {
      position: absolute;
      display: inline-block;
      width: 40px;
      box-sizing: border-box;
      cursor: pointer;
      border: none;
      background-color: transparent;
      padding: 10px;
      right: 20px;
      top: 6px;
      .desktop {
        display: block;
      }
      .mobile {
        display: none;
      }
    }
  }

  .modalBody {
    position: relative;
    box-sizing: border-box;
    padding: 26px;
    max-height: calc(100% - 56px);
    overflow: scroll;
  }

  @media screen and (max-width: ${ResponsiveSize.TABLET_MAX_WIDTH}px) {
    margin-top: 0px;
    height: 100%;
    max-height: 100%;

    div[class^='Card'] {
      height: 100%;
      border-radius: 0px;
    }

    .modalHeader {
      height: 49px;
      button {
        padding: 6px;
        top: 6px;
        left: 10px;
        .desktop {
          display: none;
        }
        .mobile {
          display: block;
        }
      }
    }
  }
`

interface Props {
  title: string
  close: () => void
}
const Confirm: FC<PropsWithChildren<Props>> = ({ title, children, close }) => {
  return (
    <ModalCointainer>
      <Card radius={16} padding={0} hasBorder={false}>
        <div className="modalHeader">
          <Text element="h4" type="title4">
            {title}
          </Text>
          <button onClick={close}>
            <div className="desktop">
              <Icon name={IconPack.GENERAL_ACTION_EXIT_GRAY} width="24" height="24" />
            </div>
            <div className="mobile">
              <Icon name={IconPack.GENERAL_ACTION_BACK_BLACK} width="24" height="24" />
            </div>
          </button>
        </div>
        <div className="modalBody">{children}</div>
      </Card>
    </ModalCointainer>
  )
}

export default Confirm
